"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CCurrencyAmount = void 0;
var currency_1 = require("../../account/currency");
var enums_1 = require("../../account/enums");
var CCurrencyAmount = /** @class */function () {
  function CCurrencyAmount(values) {
    if (values === void 0) {
      values = {};
    }
    var properties = ['currency_id', 'amount'];
    var instance = this;
    properties.forEach(function (p) {
      if (p in values) {
        instance[p] = values[p];
      }
    });
  }
  Object.defineProperty(CCurrencyAmount, "defaultAmount", {
    get: function () {
      return new CCurrencyAmount({
        amount: 0,
        currency_id: enums_1.CurrencyEnum.usd
      });
    },
    enumerable: false,
    configurable: true
  });
  CCurrencyAmount.prototype.format = function () {
    var _a;
    return (_a = currency_1.currencies[this.currency_id]) === null || _a === void 0 ? void 0 : _a.format(this.amount);
  };
  CCurrencyAmount.prototype.formatFixed = function (fraction) {
    var _a;
    return (_a = currency_1.currencies[this.currency_id]) === null || _a === void 0 ? void 0 : _a.formatFixed(this.amount, fraction);
  };
  return CCurrencyAmount;
}();
exports.CCurrencyAmount = CCurrencyAmount;
